<template>
    <div class="d-flex flex-column mt-3">
        <label
            for=""
            class="font-14"
        >
            Design personalizado da galeria
        </label>

        <flicker-carousel 
            :activeItemValue="galleryActive"
            :items="galleries.filter(item => {
                return !item.hasComments && !item.hasSidebar
            })"
            :handleClick="handleClick"
        />
    </div>
</template>

<script>
import FlickerCarousel from "../atoms/FlickerCarousel.vue";
import { mapGetters } from 'vuex';

export default {
    name: 'SettingFrameTypeGallery',
    components: {
        FlickerCarousel
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            galleries: [],
            galleryActive: 0
        }
    },
    methods: {
        handleClick(idGallery) {
            this.item.extra.maincontent_gallery_id = idGallery;
            
            this.galleries.find(gallery => {
                if (gallery.id === idGallery) {
                    this.item.extra.maincontent_gallery = gallery.variables.maincontent_gallery;
                    this.item.extra.maincontent_gallery_items = gallery.variables.maincontent_gallery_items;
                    this.item.extra.maincontent_gallery_items_mobile = gallery.variables.maincontent_gallery_items_mobile;
                    this.item.extra.maincontent_gallery_items_crop = gallery.variables.maincontent_gallery_items_crop;
                    this.item.extra.maincontent_gallery_padding = gallery.variables.maincontent_gallery_padding;
                }
            });

            // garantindo reatiovidade do componente de seleção da galeria
            this.galleryActive = idGallery;

            this.$emit('onChangeTypeGallery', this.item.extra);
        }
    },
    computed: {
        ...mapGetters('dashboardModule', ['getFrameGalleryDefaultType', 'getTemplateOrgnamismsCombinationsMaincontent']),
    },
    created() {
        this.galleries[0] = this.getFrameGalleryDefaultType;

        for (let index = 1; index < this.getTemplateOrgnamismsCombinationsMaincontent.length; index++) {
            this.galleries[index] = this.getTemplateOrgnamismsCombinationsMaincontent[index - 1];
        }

        this.galleryActive = this.item.extra.maincontent_gallery_id || 0;
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameTypeGallery.vue